var _style, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoomplay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 40",
    style: {
      enableBackground: "new 0 0 125 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#111111;}\r\n\t.st1{fill:#00FFFF;}\r\n\t.st2{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13.1,
    cy: 20,
    r: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.5,19.3c0,0,3.1-0.3,3.1-3.4c0-1.3-1-3.4-3.5-3.4h-4.6c-0.3,0-0.5,0.2-0.6,0.5l-0.3,1.2 c0,0.1,0,0.2,0.1,0.2L14,15c0,0,0,0,0,0l0.1,0l0,0c0.7,0.1,1.3,0.7,1.3,1.5c0,0.8-0.7,1.6-1.5,1.6c-0.9,0-1.6-0.7-1.6-1.5 c0-0.3,0.1-0.6,0.2-0.8l0,0l-3-0.4c-0.1,0-0.2,0-0.2,0.1l-1.1,4.9c0,0.1,0.1,0.2,0.2,0.2l5.1,0.7c0,0,0,0,0.1,0l0.1,0l0,0 c0.9,0.2,1.6,1,1.5,2c-0.1,1-0.9,1.7-1.9,1.7c-1,0-1.8-0.9-1.8-1.9c0-0.4,0.2-0.8,0.4-1.1l0,0l-3.8-0.5c-0.1,0-0.2,0.1-0.2,0.2 l-0.9,4c-0.2,0.9,0.5,1.7,1.4,1.7h6.8c2.2,0,4-1.8,4-4C19.3,21.3,17.6,19.3,15.5,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.4,19.7c1.4-0.5,2.9-1.5,2.9-3.5c0-1.6-1.1-3.5-4.3-3.5h-5.4c-0.2,0-0.4,0.1-0.4,0.3l-3,13.8 c-0.1,0.2,0.1,0.5,0.4,0.5h5.8c4.7,0,6.7-1.7,6.7-4.4C42.2,20.1,39.4,19.7,39.4,19.7z M36,24.4c-1,0-2.6,0-2.6,0l0.7-3.1 c0.5,0,1.8,0,2.5,0c0.9,0,1.4,0.5,1.4,1.4C38,23.5,37.3,24.4,36,24.4z M37.1,18.5c-0.9,0-2,0-2.4,0l0.6-2.9c0,0,1.7,0,2.3,0 c0.8,0,1.2,0.7,1.2,1.3C38.8,17.4,38.3,18.5,37.1,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.4,18c-1.5-1.8-5.6-2.1-8.2,0.1c-2.6,2.2-2.8,5.8-1.2,7.8c1.2,1.6,5.4,2.1,8.1-0.1 C54.6,23.6,55.1,19.9,53.4,18z M50.3,22.7c-0.6,1.2-1.8,1.8-2.7,1.4c-0.9-0.4-1.2-1.8-0.6-3c0.6-1.2,1.8-1.8,2.7-1.4 C50.6,20.1,50.9,21.5,50.3,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.8,18c-1.5-1.8-5.6-2.1-8.2,0.1c-2.6,2.2-2.8,5.8-1.2,7.8c1.2,1.6,5.4,2.1,8.1-0.1 C66,23.6,66.4,19.9,64.8,18z M61.7,22.7c-0.6,1.2-1.8,1.8-2.7,1.4c-0.9-0.4-1.2-1.8-0.6-3c0.6-1.2,1.8-1.8,2.7-1.4 C62,20.1,62.3,21.5,61.7,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81,16.5c-2.1,0-3.5,1.1-4.1,1.9c0,0,0.1-1.9-2.3-1.9c-2.4,0-3.7,1.3-4.2,1.9l0.4-1.8h-2.9 c-0.3,0-0.5,0.2-0.5,0.4L65.2,27h3.7c0,0,1.1-5,1.2-5.7c0.2-0.7,0.7-1.5,1.7-1.5c0.7,0,1.1,0.7,0.9,1.5c-0.2,0.9-1.2,5.7-1.2,5.7 h3.7c0,0,1.1-5.2,1.3-5.9s0.7-1.4,1.7-1.4c0.6,0,1.1,0.7,0.9,1.5C78.9,22,77.8,27,77.8,27h3.7c0,0,1.3-5.8,1.6-7.3 C83.4,18.2,83.1,16.5,81,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M99.3,23c0.2-1,2.3-10.4,2.3-10.4h-3.2c-0.3,0-0.5,0.2-0.6,0.5c-0.4,2-2.2,10-2.5,11.3c-0.3,1.5,0.2,3,2.4,3 c1.8,0,2.7-0.6,2.7-0.6L101,24c0,0-0.4,0.3-1,0.3C99.5,24.3,99.1,24,99.3,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.5,16.5c-2.3,0-3.7,2-3.7,2l0.4-1.9h-2.8c-0.3,0-0.5,0.2-0.6,0.5l-3,14.1h3.7l1.3-6.1c0,0,0.1,2.1,2.7,2.1 c2.6,0,5.6-2.8,5.6-6.4C95.2,18.2,93.8,16.5,91.5,16.5z M88.9,24.2c-1.2,0-1.5-1.1-1.5-1.8c0-1.8,1.5-2.8,2.4-2.8 c1.1,0,1.5,1.1,1.5,1.8C91.3,22.9,90,24.2,88.9,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.7,23c0.2-0.9,1.3-5.9,1.3-5.9h-3l-0.3,1.2c0,0-1.1-1.9-3.4-1.9c-2.4,0-5.6,2.3-5.6,6.4 c0,1.4,0.5,4.2,3.7,4.2c2.5,0,3.8-2,3.8-2s-0.3,1.7,1.6,1.7c1.1,0,1.8-0.4,1.8-0.4l0.6-2.8C113.2,23.8,112.5,23.9,112.7,23z  M107.2,24.2c-1,0-1.5-1-1.5-1.8c0-1.6,1.3-2.8,2.4-2.8c0.9,0,1.6,0.8,1.6,1.9C109.7,23.1,108.2,24.2,107.2,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.6,16.5c0,0-1.7,4-3.1,6.6l-0.5-6.6h-3.4l1.4,10.3c0,0-0.9,1.6-2.9,1.6c-0.1,0-0.4,0-0.4,0l-0.6,2.8 c0,0,0.7,0,1.1,0c2.5,0,4.4-1.2,5.6-3.1c1.2-1.8,6.4-11.6,6.4-11.6H121.6z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st2",
    width: 125,
    height: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoomplay);
export default __webpack_public_path__ + "static/media/boomplay.5af364aa7b7695cb94113518b4428445.svg";
export { ForwardRef as ReactComponent };